<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <div class="text" v-bind="$attrs" :style="style">{{ displayText }}</div>
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script setup lang="ts">
import { computed, _, useHostAppInstance } from '@zto/zpage'

const props = withDefaults(
  defineProps<{
    model: Record<string, any>
    prop: string
    text?: string
    tpl?: string
    formatter?: string | Record<string, any> | Function
    emptyText?: string
    style?: Record<string, any>
  }>(),
  {
    emptyText: '--'
  }
)

const app = useHostAppInstance()

const displayText = computed(() => {
  let text = props.model[props.prop] || props.text || ''

  if (props.formatter) {
    text = app.formatText(text, props.formatter, { model: props.model })
  } else if (props.tpl) {
    text = app.filter(props.tpl, props.model)
  }

  if (props.emptyText && _.isEmpty(text)) {
    return props.emptyText
  }

  return text
})
</script>
